module.exports = __webpack_public_path__ + "static/media/additionalLight.68ce7ab0.svg";